<template>
  <div :class="wrapperClass" :style="wrapperStyle">
    <!-- DESKTOP -->
    <div v-if="!$is_tablet_lower_view" class="be-reservation-summary">
      <div class="be-reservation-summary__header">
        <p class="be-reservation-summary__label">
          {{ $t('hotel.reservation-summary') }}
        </p>
        <p class="be-reservation-summary__merchant">
          {{ getMerchant.name }}
        </p>
        <p
          class="be-reservation-summary__stay"
          v-if="getMerchant.additional_appearance === 'CART' && getBeCartRoom.length > 0">
          {{ cartTotalGuest }} {{ $t('hotel.guests.guests') }},
          {{ getBeCart.qty.room_rate }}
          {{ $t('hotel.unit-type.' + getBeRoomTypeSummaryType + '.unit') }},
          {{ cartTotalDate }} {{ $t('hotel.night') }}
        </p>
      </div>

      <div
        class="be-reservation-summary__row be-anim-fade-up be-anim-fade-up--fast"
        v-for="(cart_list, index) in getBeCartRoom"
        :key="index">
        <div class="be-reservation-summary__row-info">
          <p class="be-reservation-summary__rate">{{ cart_list.room_rate.name }}</p>
          <p class="be-reservation-summary__type">
            {{ cart_list.room_rate.room_type.name }}
          </p>
          <p class="be-reservation-summary__guest">
            {{ $printTotalGuestPerRoom(cart_list) }}
          </p>
        </div>
        <div class="be-reservation-summary__row-price">
          <p class="be-reservation-summary__price">
            {{ $formatCurrency($calculateSubTotalPerRoom(cart_list)) }}
          </p>
          <p class="be-reservation-summary__qty">
            {{ cart_list.qty }}
            {{ $t('hotel.unit-type.' + cart_list.room_rate.room_type.type + '.units') }}
          </p>
          <p class="be-reservation-summary__remove" @click="removeRoomRate(cart_list)">
            {{ $t('hotel.remove') }}
          </p>
        </div>
      </div>

      <div class="be-reservation-summary__notice-wrap" v-if="isUnderSearchPax">
        <div class="be-reservation-summary__notice">
          <p class="be-reservation-summary__notice-text">{{ isUnderSearchPax }}</p>
        </div>
      </div>

      <ProductAdditional page="SEARCH" />

      <div class="be-reservation-summary__notice-wrap" v-if="showWarningRequiredRoom">
        <div class="be-reservation-summary__notice">
          <p class="be-reservation-summary__notice-text">
            The product you selected requires a room booking. Please choose a
            room in the "Room" tab.
          </p>
        </div>
      </div>

      <div class="be-reservation-summary__footer">
        <div class="be-reservation-summary__total">
          <p class="be-reservation-summary__total-label">{{ $t('hotel.total') }}</p>
          <p
            class="be-reservation-summary__total-price"
            :class="{ 'be-pop': isTotalPulsing }">
            {{ $formatCurrency(totalPrice) }}
          </p>
        </div>
        <div class="w-100" v-if="showPreviewCart">
          <div v-if="disabledReservationButton || showWarningRequiredRoom">
            <button
              v-b-tooltip="isUnderSearchPax"
              class="be-reservation-summary__cta be-reservation-summary__cta--disabled">
              {{ $t('hotel.reservation') }}
            </button>
          </div>
          <template v-else>
            <div @click="trackReservationClick()">
              <router-link :to="'/' + getMerchant.code + '/cart'">
                <button class="be-reservation-summary__cta be-press">
                  {{ $t('hotel.reservation') }}
                </button>
              </router-link>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- MOBILE -->
    <template v-if="$is_tablet_lower_view && showPreviewCart">
      <p
        v-if="isUnderSearchPax"
        class="be-reservation-summary__mobile-warning">
        {{ isUnderSearchPax }}
      </p>
      <p
        v-if="showWarningRequiredRoom"
        class="be-reservation-summary__mobile-warning">
        The product you selected requires a room booking
      </p>
      <div class="be-reservation-summary__bar">
        <div @click="toggleDetail(true)" class="be-reservation-summary__bar-info">
          <p class="be-reservation-summary__bar-price">
            {{ $formatCurrency(totalPrice) }}
          </p>
          <p class="be-reservation-summary__bar-detail">
            {{ $t('hotel.detail') }}
          </p>
        </div>
        <div>
          <router-link
            :to="'/' + getMerchant.code + '/cart'"
            :class="{
              'total-disabled':
                disabledReservationButton || showWarningRequiredRoom,
            }"
            @click.native="
              disabledReservationButton || showWarningRequiredRoom
                ? $event.preventDefault()
                : null
            ">
            <button
              @click="trackReservationClick()"
              type="button"
              class="be-reservation-summary__bar-cta">
              {{ $t('hotel.reservation')
              }}<img
                src="../../../../assets/img/icon/back-white.png"
                class="be-reservation-summary__bar-icon"
                width="18" />
            </button>
          </router-link>
        </div>
      </div>

      <popup-detail
        id_ref="detail-preview-cart"
        direction="bottom"
        :show="showDetail"
        use_max_size
        use_footer
        wrapper_size="mobile"
        title="Reservation Summary"
        @close="toggleDetail">
        <template v-slot:body>
          <div class="be-reservation-summary__sheet">
            <div
              class="be-reservation-summary__row be-reservation-summary__row--sheet be-anim-fade-up be-anim-fade-up--fast"
              v-for="(cart_list, index) in getBeCartRoom"
              :key="index">
              <div class="be-reservation-summary__row-info">
                <p class="be-reservation-summary__rate">
                  {{ cart_list.room_rate.name }}
                </p>
                <p class="be-reservation-summary__type">
                  {{ cart_list.room_rate.room_type.name }}
                </p>
                <p class="be-reservation-summary__guest">
                  {{ cart_list.room_rate.rate.guest_included }} person /
                  {{
                    $t(
                      'hotel.unit-type.' +
                        cart_list.room_rate.room_type.type +
                        '.per-unit'
                    )
                  }}
                </p>
              </div>
              <div class="be-reservation-summary__row-price">
                <p class="be-reservation-summary__price">
                  {{ $formatCurrency($calculateSubTotalPerRoom(cart_list)) }}
                </p>
                <p class="be-reservation-summary__qty">
                  {{ cart_list.qty }}
                  {{
                    $t(
                      'hotel.unit-type.' +
                        cart_list.room_rate.room_type.type +
                        '.units'
                    )
                  }}
                </p>
                <p
                  class="be-reservation-summary__remove"
                  @click="removeRoomRate(cart_list)">
                  {{ $t('hotel.remove') }}
                </p>
              </div>
            </div>
            <div class="be-reservation-summary__notice-wrap" v-if="isUnderSearchPax">
              <div class="be-reservation-summary__notice">
                <p class="be-reservation-summary__notice-text">
                  {{ isUnderSearchPax }}
                </p>
              </div>
            </div>
            <ProductAdditional bg-color="bg-white" page="SEARCH" />
            <div class="be-reservation-summary__notice-wrap" v-if="showWarningRequiredRoom">
              <div class="be-reservation-summary__notice">
                <p class="be-reservation-summary__notice-text">
                  The product you selected requires a room booking. Please
                  choose a room in the "Room" tab.
                </p>
              </div>
            </div>
          </div>
        </template>

        <template v-slot:footer>
          <div class="be-reservation-summary__sheet-footer">
            <div class="be-reservation-summary__total">
              <p class="be-reservation-summary__total-label">
                {{ $t('hotel.total') }}
              </p>
              <p
                class="be-reservation-summary__total-price"
                :class="{ 'be-pop': isTotalPulsing }">
                {{ $formatCurrency(totalPrice) }}
              </p>
            </div>
            <div v-if="disabledReservationButton || showWarningRequiredRoom">
              <button
                v-b-tooltip="`${isUnderSearchPax}`"
                class="be-reservation-summary__cta be-reservation-summary__cta--disabled">
                {{ $t('hotel.reservation') }}
              </button>
            </div>
            <template v-else>
              <div @click="trackReservationClick()">
                <router-link :to="'/' + getMerchant.code + '/cart'">
                  <button class="be-reservation-summary__cta be-press">
                    {{ $t('hotel.reservation') }}
                  </button>
                </router-link>
              </div>
            </template>
          </div>
        </template>
      </popup-detail>
    </template>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapMutations } from 'vuex';
import ProductAdditional from '../additionalService/ProductCart.vue';

/* matches the bePop keyframe length in be-v3-motion.css */
const TOTAL_PULSE_MS = 260;

export default {
  name: 'BeReservationSummary',
  components: {
    ProductAdditional,
  },
  props: {
    module: {
      type: String,
      default: 'ROOM',
    },
    config: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showDetail: false,
      isTotalPulsing: false,
    };
  },
  computed: {
    ...mapGetters([
      'getMerchant',
      'getBeCartRoom',
      'getBeFilter',
      'getBeCart',
      'getBeRoomTypeSummaryType',
      'getBeRoomTotal',
      'getBeAddtServiceSubTotal',
      'isUnderSearchPax'
    ]),
    totalAdditionalService() {
      return this.getBeAddtServiceSubTotal + this.$totalAddtServiceModule();
    },
    totalGreenTax(){
      const { deposit, pay_later } = this.$greenTaxes();
      return deposit + pay_later;
    },
    totalRoomPrice(){
      const { search_room_is_show_tax_fee_note: showTaxes } = this.getMerchant;
      return showTaxes ? this.getBeRoomTotal + this.totalGreenTax : this.getBeRoomTotal;
    },
    showPreviewCart(){
      const roomIsExist = this.$isNotEmptyV2(this.getBeCartRoom);
      return roomIsExist || this.totalAdditionalPriceShow > 0
    },
    totalAdditionalPriceShow(){
      const { additional_appearance } = this.getMerchant;
      if(additional_appearance !== 'SEARCH_ROOM') return 0;

      return this.getBeAddtServiceSubTotal + this.$totalAddtServiceModule();
    },
    totalPrice(){
      return this.totalRoomPrice + this.totalAdditionalPriceShow
    },
    wrapperClass() {
      if (this.$is_tablet_lower_view) {
        return this.showPreviewCart ? 'w-100 position-fixed bg-white border-t-form z-index-1040 p-2-5' : '';
      } else {
        let cssClass = 'sticky mb-2';
        if (this.module === 'ADDITIONAL') return cssClass;

        const {
          header_scroll = null,
          show_rate = null,
          show_rate_breakdown = null,
        } = this.config;

        if (
          this.$isEmpty(header_scroll) ||
          this.$isEmpty(show_rate) ||
          this.$isEmpty(show_rate_breakdown)
        )
          return '';

        const isTop5 =
          (!header_scroll || show_rate || show_rate_breakdown) &&
          this.getMerchant.booking_engine_header_type == 'BANNER';
        const isTop90 =
          (!header_scroll || show_rate || show_rate_breakdown) &&
          this.getMerchant.booking_engine_header_type == 'NAVBAR';

        if (isTop5) cssClass += ' top-5';
        if (isTop90) cssClass += ' top-90';
        return cssClass;
      }
    },
    wrapperStyle() {
      if (this.$is_tablet_lower_view) {
        return 'bottom:0px;left:0;';
      } else {
        if (this.module === 'ROOM') return 'top: 165px;';
        return '';
      }
    },
    cartTotalGuest() {
      const { adult, child, infant } = this.getBeFilter.guest;
      let totalGuest = parseInt(adult) + parseInt(child) + parseInt(infant);
      return parseInt(totalGuest);
    },
    cartTotalDate() {
      var diff = 0;
      const { check_in, check_out } = this.getBeFilter.date;
      let checkInFormatted = moment(check_in).format('YYYY-MM-DD');
      let checkOutFormatted = moment(check_out).format('YYYY-MM-DD');
      diff =
        moment(checkOutFormatted).diff(moment(checkInFormatted)) /
        (1000 * 3600 * 24);
      return diff;
    },
    disabledReservationButton() {
      if (this.getBeRoomTotal > 0) {
        return (
          this.getMerchant.use_total_max_guest_restriction &&
          this.$isNotEmptyV2(this.isUnderSearchPax)
        );
      }
      return false;
    },
    showWarningRequiredRoom() {
      return (
        this.getMerchant.additional_appearance === 'SEARCH_ROOM' &&
        this.getBeAddtServiceSubTotal > 0 &&
        this.getBeRoomTotal === 0
      );
    },
  },
  watch: {
    totalPrice(newTotal, oldTotal) {
      if (
        this.$is_tablet_lower_view &&
        this.showDetail &&
        newTotal === 0 &&
        oldTotal > 0
      ) {
        this.toggleDetail();
      }

      if (newTotal !== oldTotal) this.pulseTotal();
    },
  },
  beforeDestroy() {
    clearTimeout(this.totalPulseTimer);
  },
  methods: {
    ...mapMutations(['beRemoveRoomRate', 'changeBeRoomAvbl']),
    pulseTotal() {
      clearTimeout(this.totalPulseTimer);
      this.isTotalPulsing = false;
      // let the class drop for a frame so re-adding it restarts the keyframes
      this.$nextTick(() => {
        this.isTotalPulsing = true;
        this.totalPulseTimer = setTimeout(() => {
          this.isTotalPulsing = false;
        }, TOTAL_PULSE_MS);
      });
    },
    removeRoomRate(cart) {
      const { id, room_type } = cart.room_rate;

      this.beRemoveRoomRate(id);
      const roomTypeParams = {
        id: room_type.id,
        rr_id: id,
        qty: cart.qty,
        action: 'inc',
        is_virtual: room_type.is_virtual,
        availability_affected: room_type.availability_affected,
      };
      this.changeBeRoomAvbl(roomTypeParams);
    },
    trackReservationClick() {
      this.$track('add_to_cart');
      if (!this.$hasGoogleTag()) return;
      this.$gtag('event','goto_cart', { method: 'Google' });
    },
    toggleDetail(show = false) {
      this.showDetail = show;
    },
  },
};
</script>

<style scoped>
.be-reservation-summary {
  background: #fff;
  border: 1px solid var(--be-v3-border, #d5d9e0);
  border-radius: var(--be-v3-radius, 12px);
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  font-family: var(--be-v3-content-font, BeV3Sans), sans-serif;
  margin: 8px 0;
}

/* HEADER */
.be-reservation-summary__header {
  background: var(--merchant-primary-color, #6d6a6a);
  padding: 20px;
  color: #fff;
}
.be-reservation-summary__label {
  margin: 0;
  font-size: var(--be-v3-text-caption, 0.75rem);
  font-weight: 500;
  opacity: 0.9;
}
.be-reservation-summary__merchant {
  margin: 2px 0 0;
  font-family: var(--be-v3-title-font, var(--be-v3-content-font, BeV3Sans)), sans-serif;
  font-size: var(--be-v3-text-heading, 1.0625rem);
  font-weight: 700;
  line-height: 1.2;
}
.be-reservation-summary__stay {
  margin: 6px 0 0;
  font-size: var(--be-v3-text-caption, 0.75rem);
  font-weight: 500;
}

/* ROOM ROW */
.be-reservation-summary__row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  background: #f7f8fa;
  border-bottom: 1px solid var(--be-v3-border, #e6e8ec);
}
.be-reservation-summary__row--sheet {
  background: #fff;
}
.be-reservation-summary__row-info {
  text-align: left;
  min-width: 0;
}
.be-reservation-summary__row-price {
  text-align: right;
  flex-shrink: 0;
}
.be-reservation-summary__rate {
  margin: 0;
  font-size: var(--be-v3-text-caption, 0.75rem);
  color: #8a8f98;
}
.be-reservation-summary__type {
  margin: 2px 0;
  font-size: var(--be-v3-text-secondary, 0.8125rem);
  font-weight: 700;
  color: #1a1a2e;
}
.be-reservation-summary__guest {
  margin: 0;
  font-size: var(--be-v3-text-caption, 0.6875rem);
  color: #8a8f98;
}
.be-reservation-summary__price {
  margin: 0;
  font-size: var(--be-v3-text-secondary, 0.8125rem);
  font-weight: 700;
  color: #1a1a2e;
}
.be-reservation-summary__qty {
  margin: 2px 0;
  font-size: var(--be-v3-text-caption, 0.6875rem);
  color: #8a8f98;
}
.be-reservation-summary__remove {
  margin: 0;
  font-size: var(--be-v3-text-caption, 0.6875rem);
  color: #dc3545;
  text-decoration: underline;
  cursor: pointer;
}

/* NOTICE */
.be-reservation-summary__notice-wrap {
  padding: 16px 20px;
  border-bottom: 1px solid var(--be-v3-border, #e6e8ec);
}
.be-reservation-summary__notice {
  width: 100%;
  padding: 12px;
  text-align: center;
  border: 1px solid rgb(254, 207, 184);
  background-color: rgb(255, 246, 243);
  border-radius: var(--be-v3-radius, 8px);
}
.be-reservation-summary__notice-text {
  margin: 0;
  font-size: var(--be-v3-text-caption, 0.8125rem);
  color: #333;
}

/* FOOTER */
.be-reservation-summary__footer {
  padding: 20px;
}
.be-reservation-summary__total {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.be-reservation-summary__total-label {
  margin: 0;
  font-size: var(--be-v3-text-secondary, 0.875rem);
  font-weight: 600;
  color: #1a1a2e;
}
.be-reservation-summary__total-price {
  margin: 0;
  font-size: var(--be-v3-text-price, 1.0625rem);
  font-weight: 700;
  color: #1a1a2e;
}
.be-reservation-summary__cta {
  width: 100%;
  margin-top: 16px;
  padding: 11px;
  border: none;
  background: var(--merchant-button-color, var(--merchant-primary-color, #c69c6d));
  color: #FFF;
  border-radius: var(--be-v3-button-radius, 8px);
  font-size: var(--be-v3-text-secondary, 0.875rem);
  font-weight: 600;
  cursor: pointer;
}
.be-reservation-summary__cta--disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* MOBILE BAR */
.be-reservation-summary__mobile-warning {
  margin: 0 0 8px;
  font-size: var(--be-v3-text-caption, 0.8125rem);
  color: #dc3545;
  width: 100%;
  text-align: center;
}
.be-reservation-summary__bar {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--merchant-primary-color, #6d6a6a);
  border-radius: var(--be-v3-radius, 8px);
  padding: 8px 8px 8px 16px;
}
.be-reservation-summary__bar-info {
  flex: 1 1 auto;
  cursor: pointer;
}
.be-reservation-summary__bar-price {
  margin: 0;
  font-size: var(--be-v3-text-body, 0.875rem);
  font-weight: 700;
  color: #fff;
}
.be-reservation-summary__bar-detail {
  margin: 0;
  font-size: var(--be-v3-text-caption, 0.75rem);
  color: rgba(255, 255, 255, 0.85);
}
.be-reservation-summary__bar-cta {
  display: flex;
  align-items: center;
  border: none;
  background: var(--merchant-button-color, var(--merchant-primary-color, #c69c6d));
  color: var(--merchant-text-color, #fff);
  border-radius: var(--be-v3-button-radius, 8px);
  padding: 10px 12px;
  font-size: var(--be-v3-text-body, 0.875rem);
  font-weight: 600;
  cursor: pointer;
}
.be-reservation-summary__bar-icon {
  margin-left: 6px;
  position: relative;
  top: -1px;
  transform: rotate(180deg);
}
.total-disabled {
  opacity: 0.5;
  pointer-events: none;
}

/* MOBILE SHEET */
.be-reservation-summary__sheet {
  width: 100%;
  min-height: 30vh;
  font-family: var(--be-v3-content-font, BeV3Sans), sans-serif;
}
.be-reservation-summary__sheet-footer {
  padding: 12px 20px;
  font-family: var(--be-v3-content-font, BeV3Sans), sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/be/v3/BeReservationSummary.vue